import { useState } from "react"
import clsx from "clsx"

import { GgrUsageBadge } from "features/ggr/GgrUsageBadge"

import { useProps } from "contexts/PropsContext"

import { ReactComponent as BellIcon } from "../../assets/icons/bell.svg"
import { TwoFactorManageModal } from "../modals/ModalTwoFactorManage"
import { TwoFactorSetupModal } from "../modals/ModalTwoFactorSetup"

import { UserDropdown } from "./UserDropdown"

export interface TopBarProps {
  title: string
}

export const TopBar = ({ title }: TopBarProps) => {
  const { darkMode, refreshUser } = useProps()

  const [twoFactorModalOpen, setTwoFactorModalOpen] = useState(false)
  const [manageModalOpen, setManageModalOpen] = useState(false)

  const handle2FASuccess = () => {
    refreshUser()
  }

  return (
    <>
      <div
        className={`sticky top-0 z-40 w-full py-6 border-b sm: dark:border-[rgba(255,255,255,0.1)] border-[rgba(0,0,0,0.05)] border-white hidden lg:block ${
          darkMode ? "bg-[#060715]" : "bg-white"
        }`}
      >
        <div
          className={clsx(
            "flex items-center justify-between sm:px-6 sm:py-[19px] rounded-xl w-full bg-transparent sm:border",
            darkMode
              ? "sm:bg-[#131421] border-[rgba(255,255,255,0.1)] text-white"
              : "sm:bg-white border-[rgba(0,0,0,0.05)] text-black backdrop-blur-[9px] shadow-[0px_3px_6px_0px_rgba(192,192,192,0.4)]"
          )}
        >
          <h1 className="text-4xl sm:text-2xl font-semibold">{title}</h1>

          <div className="flex items-center gap-4">
            <GgrUsageBadge />
            <div
              className={clsx(
                "flex items-center justify-center relative w-12 h-12 rounded-full border",
                darkMode ? "bg-[#21222E] border-[rgba(255,255,255,0.1)]" : "bg-[#F9FAFB] border-gray-200"
              )}
            >
              <BellIcon className={`w-6 h-6 ${darkMode ? "text-[rgba(205,208,213,1)]" : "text-[#060715]"}`} />
              <span className="absolute top-0 right-0 transform translate-x-1 -translate-y-1 text-xs font-semibold bg-[#F43F5E] text-white rounded-full px-1.5 py-0.5">
                3
              </span>
            </div>

            <UserDropdown onOpenTwoFactorSetup={() => setTwoFactorModalOpen(true)} onOpenTwoFactorManage={() => setManageModalOpen(true)} />
          </div>
        </div>
      </div>
      <TwoFactorSetupModal isOpen={twoFactorModalOpen} onClose={() => setTwoFactorModalOpen(false)} onSuccess={handle2FASuccess} />
      <TwoFactorManageModal isOpen={manageModalOpen} onClose={() => setManageModalOpen(false)} onSuccess={handle2FASuccess} />
    </>
  )
}
